(function () {
  if (window.cmDeliveryEtaInit) return;
  window.cmDeliveryEtaInit = true;

  function cmIsWeekend(d) {
    const day = d.getDay();
    return day === 0 || day === 6;
  }

  function cmAddBusinessDays(date, businessDays) {
    const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    let added = 0;
    while (added < businessDays) {
      d.setDate(d.getDate() + 1);
      if (!cmIsWeekend(d)) added++;
    }
    return d;
  }

  function cmCapitalize(s){ return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }

  function cmFormatWeekdayDa(d) {
    return cmCapitalize(new Intl.DateTimeFormat('da-DK', { weekday: 'long' }).format(d));
  }

  function cmComputeDeliveryDate(cutoffHour) {
    const now = new Date();
    const beforeCutoff = now.getHours() < cutoffHour;
    const businessDaysToAdd = beforeCutoff ? 1 : 2;
    return cmAddBusinessDays(now, businessDaysToAdd);
  }

  function cmBuildText(cutoffHour) {
    const now = new Date();
    const deliveryDate = cmComputeDeliveryDate(cutoffHour);

    const isWeekdayToday = now.getDay() >= 1 && now.getDay() <= 5;
    const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const isTomorrowWeekday = tomorrow.getDay() >= 1 && tomorrow.getDay() <= 5;

    if (isWeekdayToday && now.getHours() < cutoffHour && isTomorrowWeekday) {
      return 'I morgen';
    }
    return cmFormatWeekdayDa(deliveryDate);
  }

  function cmUpdateOne(el) {
    if (!el) return;
    const dateEl = el.querySelector('.cm-delivery-eta__date');
    if (!dateEl) return;

    const cutoffHour = parseInt(el.getAttribute('data-cutoff-hour') || '14', 10);
    const nextText = cmBuildText(cutoffHour);

    if (dateEl.textContent !== nextText) dateEl.textContent = nextText;
  }

  function cmUpdateAll(scope) {
    (scope || document).querySelectorAll('.cm-delivery-eta').forEach(cmUpdateOne);
  }

  let cmTicking = false;
  function cmSchedule(scope) {
    if (cmTicking) return;
    cmTicking = true;
    requestAnimationFrame(function () {
      cmTicking = false;
      cmUpdateAll(scope);
    });
  }

  // Initial
  document.addEventListener('DOMContentLoaded', function () {
    cmSchedule(document);
  });

  // ROBUST: global observer der fanger når CartDrawer / ETA markup bliver indsat igen
  const globalObs = new MutationObserver(function (mutations) {
    for (const m of mutations) {
      if (!m.addedNodes || !m.addedNodes.length) continue;

      for (const node of m.addedNodes) {
        if (!node || node.nodeType !== 1) continue;

        // Hvis hele drawer eller ETA-div’en bliver indsat, så opdater
        if (node.matches && (node.matches('#CartDrawer') || node.matches('.cm-delivery-eta'))) {
          cmSchedule(node);
          return;
        }

        // Hvis den ligger inde i noget der blev indsat
        if (node.querySelector && (node.querySelector('.cm-delivery-eta') || node.querySelector('#CartDrawer'))) {
          cmSchedule(node);
          return;
        }
      }
    }
  });

  globalObs.observe(document.body, { childList: true, subtree: true });
})();